import { Box, BoxProps, ColorOptions, Icon, Text, TextProps } from '@jfs/ui-new'
import { defaultColors } from '@jfs/ui-new/src/theme/DefaultTheme'
import { useNavigation } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { Dimensions, FlatList } from 'react-native'
import { ModBox } from '../../../comps/ModifiedBox/ModifiedBox'
import { ToastPosition, ToastType } from '../../../comps/Toast'
import { ModalTypes, UserActionPopup } from '../../../comps/UserActionPopup'
import { useLazyApiData, useStores } from '../../../data/store'
import { Routes } from '../../../nav/routes'
import { combineUserName } from '../../../util/util'

const DottedActionMenu = ({ listItems, data }: any) => {
  const navigation = useNavigation()
  const [actionMenuInfo, setActionMenuInfo] = useState({ visible: false, layoutEvent: null })
  const [confirmAlertInfo, setConfirmAlertInfo] = useState({ visible: false, type: 'block' })
  const {
    deleteUserApi,
    blockUnblockUserApi,
    mid,
    makePreviousMerchantPermissionEmpty,
    canViewBlockDeleteInUserManagement,
    canEditUserInUserManagement,
    setCustomToast,
  } = useStores((store) => ({
    deleteUserApi: store.userManagement.deleteUserApi,
    blockUnblockUserApi: store.userManagement.blockUnblockUserApi,
    mid: store.user.selectedMid,
    makePreviousMerchantPermissionEmpty: store.userManagement.makePreviousMerchantPermissionEmpty,
    canEditUserInUserManagement: store.userManagement.canEditUserInUserManagement(),
    canViewBlockDeleteInUserManagement: store.userManagement.canViewBlockDeleteInUserManagement(),
    setCustomToast: store?.response?.setCustomToast,
  }))
  const [deleteUser, deleteUserHandler] = useLazyApiData(deleteUserApi)
  const [blockUnblockUser, blockUnblockUserHandler] = useLazyApiData(blockUnblockUserApi)
  const _toggleActionMenu = () => {
    setActionMenuInfo({ ...actionMenuInfo, visible: !actionMenuInfo.visible })
  }

  useEffect(() => {
    if (blockUnblockUserHandler.state === 'fulfilled') {
      const popupType = confirmAlertInfo?.type
      const isBlockedType = popupType === 'block'
      setActionMenuInfo({ ...actionMenuInfo, visible: false })
      setConfirmAlertInfo({ ...confirmAlertInfo, visible: false })
      setCustomToast({
        toastType: ToastType.POSITIVE,
        color: defaultColors.GREEN,
        position: ToastPosition.TOP,
        message: `User has been ${isBlockedType ? 'blocked' : 'unblocked'} successfully`,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blockUnblockUserHandler.state])

  useEffect(() => {
    if (deleteUserHandler.state === 'fulfilled') {
      setConfirmAlertInfo({ ...confirmAlertInfo, visible: false })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteUserHandler.state])

  const onItemPress = (item: any) => {
    const isEdit = item?.text?.toLowerCase() === 'edit'

    const modifiedData = {
      id: data?.jfsUserId,
      name: combineUserName(data?.user?.name),
      mobileNo: data?.user?.mobile?.mobileNumber ?? 'N/A',
      email: data?.email ?? 'N/A',
      department: data?.department ?? 'N/A',
    }

    if (isEdit) {
      makePreviousMerchantPermissionEmpty(false)
      navigation?.navigate(Routes.USER_MANAGEMENT.EDIT_USER_ROLE, modifiedData)
    } else if (item?.text?.toLowerCase() === 'block' || item?.text?.toLowerCase() === 'unblock') {
      setConfirmAlertInfo({ visible: true, type: item?.text?.toLowerCase() })
    } else if (item?.text?.toLowerCase() === 'delete') {
      setConfirmAlertInfo({ type: 'delete', visible: true })
    }
  }

  const modifiedListItemData = () => {
    let actionArray = [...listItems]
    if (!canEditUserInUserManagement) {
      let indexOfItem = actionArray?.findIndex((item) => item.text === 'Edit')
      actionArray.splice(indexOfItem, 1)
    } else if (!canViewBlockDeleteInUserManagement) {
      actionArray.splice(1, 2)
    }
    return actionArray
  }

  const _onPopUpConfirmationClicked = () => {
    if (confirmAlertInfo.type === 'delete') {
      deleteUser(data?.id, mid, 'delete')
    } else if (confirmAlertInfo.type === 'block' || confirmAlertInfo.type === 'unblock') {
      blockUnblockUser(data?.id, mid, confirmAlertInfo.type)
    }
  }

  const renderActionMenu = () => {
    const _renderActionMenuItem = ({ item, index }: any) => {
      console.log(index)
      return (
        <Box
          {...styles.listItem}
          testID={'actionMenuItemTestID_' + index}
          onPress={() => {
            _toggleActionMenu()
            onItemPress(item)
            console.log(JSON.stringify(item) + JSON.stringify(data))
          }}>
          <Text fontSize={12} fontFamily="jioType-medium" color={item.color ?? 'BLACK_21'}>
            {item.text}
          </Text>
        </Box>
      )
    }

    return (
      <Box {...styles.container} testID={'actionMenuTestId'}>
        <Box
          top={actionMenuInfo?.layoutEvent?.top + actionMenuInfo?.layoutEvent?.height / 2 + 2}
          onPress={() => { }}
          right={
            Dimensions.get('window').width - actionMenuInfo?.layoutEvent?.left - actionMenuInfo?.layoutEvent?.width / 2
          }
          {...styles.shadowStyle}>
          <FlatList
            data={modifiedListItemData()}
            renderItem={_renderActionMenuItem}
            keyExtractor={(_item, index) => index.toString()}
          />
        </Box>
      </Box>
    )
  }

  return (
    <>
      <ModBox show={actionMenuInfo.visible} onPress={_toggleActionMenu}>
        {ReactDOM.createPortal(renderActionMenu(), document.body)}
      </ModBox>
      <Box
        borderWidth={1}
        width={32}
        height={30}
        borderRadius={4}
        testID={'dottedMenuTestID'}
        backgroundColor={actionMenuInfo.visible ? ('#0070B614' as ColorOptions) : 'WHITE'}
        justifyContent="center"
        alignItems="center"
        onPress={(e: any) => {
          const event = e?.nativeEvent
          const customValue = {
            top: event?.clientY - event?.offsetY,
            left: event?.clientX - event?.offsetX,
            height: actionMenuInfo?.layoutEvent?.height,
            width: actionMenuInfo?.layoutEvent?.width,
          }
          setActionMenuInfo({ ...actionMenuInfo, visible: !actionMenuInfo.visible, layoutEvent: customValue })
        }}
        borderColor={actionMenuInfo.visible ? ('#0070B629' as ColorOptions) : 'DISABLED_GREY'}
        onLayout={({ nativeEvent }) => {
          setActionMenuInfo({ ...actionMenuInfo, layoutEvent: nativeEvent.layout })
        }}>
        <Icon id="OPTIONS" size={16} color={actionMenuInfo.visible ? 'BLUE_SHADE_PRIMARY' : 'BLACK_21'} />
      </Box>
      <UserActionPopup
        visibility={confirmAlertInfo.visible}
        type={confirmAlertInfo.type as ModalTypes}
        onActionPress={_onPopUpConfirmationClicked}
        isLoading={deleteUserHandler.state === 'pending' || blockUnblockUserHandler.state === 'pending'}
        closeModal={() => setConfirmAlertInfo({ ...confirmAlertInfo, visible: false })}
        data={data}
      />
    </>
  )
}

export const DottedActionMenuWrapper = (listItems: any, user: any) => {
  return ({ }: any) => {
    return <DottedActionMenu listItems={listItems} data={user} />
  }
}

export const getActionMenuComp = (status: any, user: any): any => {
  if (status?.toLowerCase() === 'active') {
    return DottedActionMenuWrapper(
      [
        { id: 0, text: 'Edit' },
        { id: 1, text: 'Block' },
        { id: 2, text: 'Delete', color: 'RED' },
      ],
      user,
    )
  } else if (status?.toLowerCase() === 'blocked') {
    return DottedActionMenuWrapper(
      [
        { id: 1, text: 'Unblock' },
        { id: 2, text: 'Delete', color: 'RED' },
      ],
      user,
    )
  } else {
    return ''
  }
}

const styles = {
  container: {
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    position: 'absolute',
  } as BoxProps,
  shadowStyle: {
    position: 'absolute',
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 2,
    shadowColor: 'GREY_MATTE',
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: 'BRAND_COLOR_GRAY_3',
    zIndex: 5,
    backgroundColor: 'WHITE',
    flexDirection: 'column',
    underlayColor: 'WHITE',
    width: 104,
  } as BoxProps,
  listItem: {
    pv: 12,
    borderBottomWidth: 1,
    borderBottomColor: 'BORDER_COLOR',
    pl: 16,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  text: {
    fontSize: 12,
    color: 'BLACK_21',
    fontWeight: 'BOLD',
  } as TextProps,
}
